import {userRoles} from "../constants/userRoles";

const getSidebarTabs = (userData, campaignId, coveryearId, fileId, memberId) => {
  return [
    ...getCampaignNav(userData, campaignId, fileId, memberId),
    ...getSuperUserNavs(userData),
    ...getAdminNavs(userData),
    ...getCoverYearNav(userData,coveryearId, fileId, memberId)
  ];
};

const getCampaignNav = (userData, campaignId, fileId, memberId) => {
  return [campaignId ?
  {
    name: "Campaigns",
    to: "/campaign",
    items: getCampaignItems(userData, campaignId, fileId, memberId),
    asLink: true,
  } :
  {
    name: "Campaigns",
    to: "/campaign",
  }]
  return []
};

const getCampaignItems = (userData, campaignId, fileId, memberId) => {
  let items = [];
  if (!campaignId) return items;

  if (campaignId && userData.role !== userRoles.SuperUser) {
    items = [
      ...items,
      {
        name: "File upload",
        to: `/campaign/${campaignId}/upload`
      },
    ]
  }

  if (memberId) {
    items = [
      ...items,
      {
        name: "Data quality",
        to: `/campaign/${campaignId}/member/${memberId}/quality`
      },
      {
        name: "Lines of business mapping",
        to: `/campaign/${campaignId}/member/${memberId}/mapping`
      },
      {
        name: "Risks at the address file",
        to: `/campaign/${campaignId}/member/${memberId}/riskfile`
      },
      {
        name: "Appendix I",
        to: `/campaign/${campaignId}/member/${memberId}/annexi`
      },
      {
        name: "Appendix II",
        to: `/campaign/${campaignId}/member/${memberId}/annexii`
      },
      {
        name: "Appendix III",
        to: `/campaign/${campaignId}/member/${memberId}/annexiii`
      },
      {
        name: 'Data analysis',
        to: `/campaign/${campaignId}/member/${memberId}/analysis`
      }
    ]
  }

  if (campaignId && userData.role === userRoles.Admin) {
    items = [
      ...items,
      {
        name: "Reports",
        to: `/campaign/${campaignId}/reports`
      },
    ]
  }
  return items;
};

const getSuperUserNavs = (userData) => {
  let items = []
  if (userData.role === userRoles.SuperUser || userData.role === userRoles.Admin)
    items = [
      {
        name: "General data",
        to:"/general_data",
        items: [
          {
            name: "Files List",
            to: "/general_data/results",
          },
          {
            name: "Reports",
            to: "/general_data/reports",
          },
          ...items,
        ],
      },
    ];
  return items;
};

const getAdminNavs = (userData) => {
  if (userData.role === userRoles.Admin)
    return [
      {
        name: "Administration",
        to: "/admin",
        items: [
          {
            name: "Users",
            to: "/admin/users",
          },
          {
            name: "Members",
            to: "/admin/members",
          },
          {
            name: "Branch of insurance",
            to: "/admin/branch",
          },
          {
            name: "File Type",
            to: "/admin/files",
          },
        ],
      },
    ];
  return [];
};


const getCoverYearNav = (userData, coveryearId, fileId, memberId) => {
  if (userData.role === userRoles.Admin) {
    return [
      {
        name: "Cover Year",
        to: "/coveryear",
        asLink: true,
        items: [
          {
            name: "GAREAT Rates",
            to: "/coveryear/taux",
          },
          {
            name: "CCR Rates",
            to: "/coveryear/CCR",
          },
          {
            name: "CCR Threshold Rates",
            to: "/coveryear/CCR_threshold",
          },
          {
            name: "Declaring Members",
            to: "/coveryear/declaring-members"
          },
          {
            name: "CCR Group",
            to: "/coveryear/CCR_group",
          }
        ]
      }
    ]
  }
  return [];

};



export default getSidebarTabs;
